<template>
  <div>
    <div>
      <h2 class="mb-5">
        What type of contract are you looking for?
      </h2>
    </div>
    <div v-if="isFetchingContractTypes">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <Checkbox
      v-else
      @change="val => (selectedContractTypes = val)"
      :selected-values="initialSelectedContractTypes"
      :options="options"
      isLarge
      mixed
    />
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { USERS_NAMESPACE } from "@/store/modules/users";
import { ADD_USER_JOB_PREFERENCE } from "@/store/modules/users/actions";
import { createNamespacedHelpers } from "vuex";
import { FETCH_CONTRACT_TYPES_GROUPINGS } from "@/store/modules/data/actions";
import {
  GET_CONTRACT_TYPES_GROUPINGS,
  GET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS
} from "@/store/modules/data/getters";
import { map, toString } from "lodash";
import Checkbox from "@/components/common/Checkbox";
import { AUTH_NAMESPACE } from "@/store/modules/auth";

const { mapGetters: mapDataGetters, mapActions } = createNamespacedHelpers(
  DATA_NAMESPACE
);
const { mapActions: mapUserActions } = createNamespacedHelpers(USERS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "ContractTypes",
  components: {
    PrimaryButton,
    Checkbox
  },
  props: {
    userId: String
  },
  async created() {
    this.fetchContractTypes();
    this.selectedContractTypes = [...this.initialSelectedContractTypes];
  },
  data() {
    return {
      selectedContractTypes: [],
      isLoading: false
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    initialSelectedContractTypes() {
      return map(this.userData.contractTypesGroupings, "id");
    },
    options() {
      return map(this.contractTypes, ({ name, id }) => ({
        label: name,
        value: id
      }));
    },
    ...mapDataGetters({
      contractTypes: GET_CONTRACT_TYPES_GROUPINGS,
      isFetchingContractTypes: GET_IS_FETCHING_CONTRACT_TYPES_GROUPINGS
    })
  },
  methods: {
    ...mapActions({
      fetchContractTypes: FETCH_CONTRACT_TYPES_GROUPINGS
    }),
    ...mapUserActions({
      addUserJobPreference: ADD_USER_JOB_PREFERENCE
    }),
    async nextStep() {
      this.$emit("nextStep");
    },
    async handleUpload() {
      this.isLoading = true;
      await this.addContractTypes();
      this.isLoading = false;
    },
    async addContractTypes() {
      await this.addUserJobPreference({
        userId: this.userId,
        data: {
          jobPreferenceIds: map(this.selectedContractTypes, val =>
            toString(val)
          ),
          jobPreferenceType: "contract_types_grouping"
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
